// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

// import courseCertificate css modules
import courseCertificateStyles from '../courseCertificateModuleStyles.css';

function CourseCertificateListItem({ courseCertificate }) {
  return (
    <li>
      <Link to={`/course-certificates/${courseCertificate._id}`}> {courseCertificate.name}</Link>
    </li>
  )
}

CourseCertificateListItem.propTypes = {
  courseCertificate: PropTypes.object.isRequired
}

export default CourseCertificateListItem;



// WEBPACK FOOTER //
// modules/courseCertificate/components/CourseCertificateListItem.js.jsx